export default __webpack_public_path__ + "static/media/PAKOXY.cf339f89.png";